/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_MahasiswaInputs */

const en_cp_role_mahasiswa = /** @type {(inputs: Cp_Role_MahasiswaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const id_cp_role_mahasiswa = /** @type {(inputs: Cp_Role_MahasiswaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Cp_Role_MahasiswaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_mahasiswa = /** @type {((inputs?: Cp_Role_MahasiswaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_MahasiswaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_mahasiswa(inputs)
	return en_cp_role_mahasiswa(inputs)
});